module.exports = __webpack_public_path__ + "img/8.b1dd26d2.svg";